<template>
  <v-main class="customMain">
    <BackOnTop title="集點辦法" />
    <div class="info_wrappper" style="padding: 16px 32px;">
      <!-- <h3 style="margin-bottom:20px; text-align: left;color: #ff9f48; font-size: 16px; font-weight: bold;line-height: 19.2px;letter-spacing: 4%;">集點規則</h3> -->
      <p id="editor_pet" v-html="content" style="text-align: left;" />
    </div>
  </v-main>
</template>

<script>
import BackOnTop from '@/components/BackOnTop.vue'
import { getRewardActivity } from '@/apis/api.js'
export default {
  name: 'petMethod',
  components: {
    BackOnTop,
  },
  data: () => ({
    content: '',
  }),
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      this.$router.push('/login')
    }
  },
  mounted() {
    const parent = this
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      parent.$router.push('/login')
    } else {
      getRewardActivity(localStorage.getItem('phone'), localStorage.getItem('password')).then(
        function (rsp) {
          parent.$store.state.isLoading = false
          parent.content = JSON.parse(rsp).content
        }
      )
    }
  },
}
</script>
<style lang="scss" scoped></style>
